import { render, staticRenderFns } from "./ChoiceImage.vue?vue&type=template&id=2903cd44&scoped=true&"
import script from "./ChoiceImage.vue?vue&type=script&lang=js&"
export * from "./ChoiceImage.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceImage.vue?vue&type=style&index=0&id=2903cd44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903cd44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VFadeTransition,VImg,VOverlay})
